import slender from "../../assets/currentBody/slender.jpg"
import slenderSoft from "../../assets/currentBody/slenderSoft.jpg"
import defined from "../../assets/currentBody/defined.jpg"
import bulky from "../../assets/currentBody/bulky.png"
import softHeavy from "../../assets/currentBody/softHeavy.png"
import slenderF from "../../assets/currentBody/slenderF.png"
import slenderSoftF from "../../assets/currentBody/softSlenderF.png"
import tonedF from "../../assets/currentBody/tonedF.png"
import solidCurvy from "../../assets/currentBody/solidCurvy.jpg"
import softHeavyF from "../../assets/currentBody/softHeavyF.png"

export const currentBodyMale =[
    {
        id:1,
        text: "Slender",
        img:slender,
        info: "Small frame, low muscle & fat",
        position:'80% 55%'
    },
    {
        id:2,
        text: "Slender & Soft",
        img:slenderSoft,
        info: " Slim frame, softer mid-section",
        position: '60% 90%'
    },
    {
        id:3,
        text: "Defined",
        img:defined,
        info:" Lean. Tight and toned",
        position: '80% 75%'
    },
    {
        id:4,
        text: "Bulky",
        img:bulky,
        info: 'Heavier set, low muscle definition',
        position: '100% 15%'
    },
    {
        id:5,
        text: "Soft & Heavy",
        img:softHeavy,
        info:"Broad frame, higher body fat",
        position: '80% 55%'
    },
    
]
export const currentBodyFemale =[
    {
        id:1,
        text: "Slender",
        img:slenderF,
        info: "Narrow frame with low body fat",
        position: '100% 65%'
    },
    {
        id:2,
        text: "Soft & Slender",
        img:slenderSoftF,
        info: "Slim frame, soft features",
        position: '100% 0%'
    },
    {
        id:3,
        text: "Toned",
        img:tonedF,
        info: "Slim, firm, and defined",
        position: '100% 15%'
    },
    {
        id:4,
        text: "Solid & Curvy ",
        img:solidCurvy,
        info: "Wider frame and lower tone",
        position: '100% 45%'
    },
    {
        id:5,
        text: "Soft & Heavy",
        img:softHeavyF,
        info: "Larger frame, higher body fat",
        position: '100% 100%'
    },
    
]